import { LeaderboardStepsIds } from "./LeaderboardForm";

export const getTabWithErrors = (errors: { [key: string]: any }) => {
  const fieldErrorKeys = Object.keys(errors);

  const errorStepMapping: Record<string, LeaderboardStepsIds> = {
    translations: LeaderboardStepsIds.INFO,
    activity: LeaderboardStepsIds.INFO,
    labels: LeaderboardStepsIds.INFO,
    visibility: LeaderboardStepsIds.INFO,
    active: LeaderboardStepsIds.INFO,
    limits: LeaderboardStepsIds.INFO,
  };

  return Array.from(
    new Set(
      fieldErrorKeys
        .map((key) => errorStepMapping[key as keyof typeof errorStepMapping])
        .filter(Boolean),
    ),
  );
};
